var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('alert-dialog',{attrs:{"centered":"","title":_vm.$t('components.workout.signUpPrompt.dialogSaveWorkoutTitle'),"actions":[
    {
      title: _vm.$t('components.workout.signUpPrompt.dialogSaveWorkoutNo'),
      callback: _vm.handleDismiss
    },
    {
      title: _vm.$t('components.workout.signUpPrompt.dialogSaveWorkoutYes'),
      callback: _vm.handleSignUp
    }
  ],"show":_vm.show},on:{"close":_vm.handleDismiss}},[_vm._v(" "+_vm._s(_vm.$t("components.workout.signUpPrompt.dialogSaveWorkoutContent"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }